<template>
  <div>
    <div class="mx-auto mt-16 pt-2" :class="isMobile ? 'w-full px-2' : 'section'">
      <button class="w-20 px-3 mb-2 font-bold border-2 rounded-md bg-white cursor-pointer" @click="back()">
        ＜戻る
      </button>
      <div class="mt-2" :class="isMobile ? 'text-sm p-1' : 'pb-1'">
        <span v-if="$route.name === 'AddTeikiList'">
          現在お持ちの定期券の2区間目の経路を「経路確定」ボタンを押して確定してください
        </span>
        <span v-else>
          現在お持ちの定期券の経路を「経路確定」ボタンを押して確定してください
        </span>
      </div>
      <div class="w-full base-color min-h-10 mt-2">
        <div v-if="type === 'before'" class="float-left ml-2 bg-blue-600 text-white my-2 px-4 rounded-full">
          <span v-if="mode === 'fare'">
            改定前運賃
          </span>
          <span v-else>
            改定前定期運賃
          </span>
        </div>
        <div v-else class="float-left ml-2 bg-red-600 text-white my-2 px-4 rounded-full">
          <span v-if="mode === 'fare'">
            改定後運賃
          </span>
          <span v-else>
            改定後定期運賃
          </span>
        </div>
        <div v-for="(s, index) in viaList" v-bind:key="index" class="float-left font-bold my-2 text-white">
          <div v-if="index > 0" class="float-left ml-2">
            →
          </div>
          <div class="float-left ml-2">
            {{ s }}
          </div>
        </div>
        <div class="clear-both"></div>
      </div>
      <div class="text-center mx-auto mt-2">
        <div id="result" ref="result">
        </div>
      </div>
      <div v-if="errors" class="font-bold text-red-500">
        <div class="ml-6">
          <div v-for="(error, index) in errors" :key="index" type="1" v-html="error"></div>
        </div>
      </div>
      <div class="text-center mb-2 font-bold text-blue-600 underline break-all cursor-pointer mt-2" @click="top()">
        ←TOPに戻る
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Constants from '@/constants';

export default {
  data() {
    return {
      result: null,
      answerCount: 5,
      errors: null,
    }
  },
  computed: mapGetters({
    viaList: 'getViaList',
    mode: 'getMode',
    type: 'getType',
    teikiKind: 'getTeikiKind',
    teikiValidity: 'getTeikiValidity',
    isMobile: 'getIsMobile',
    serializeData: 'getSerializeData',
  }),
  async mounted() {
    if (this.$route.name === 'TeikiList') {
      if (this.serializeData.length > 0) {
        this.$store.commit('sliceSerializeData', 0);
      }
    } else if (this.$route.name === 'AddTeikiList') {
      if (this.serializeData.length > 1) {
        this.$store.commit('sliceSerializeData', 1);
      }
    }
    this.result = new window.expGuiCourse(this.$refs.result);
    this.result.setConfigure("apiURL", Constants.API_BASE_URL);
    this.result.setConfigure("CourseDisplay", 'all');
    this.result.setConfigure("PriceChange", true);
    this.result.setConfigure("PriceChangeRefresh", true);
    this.result.setConfigure("PriceChangeCallback", this.priceChange);
    if (this.isMobile) {
      this.result.setConfigure("agent", 2);
    } else {
      this.result.setConfigure("agent", 1);
    }
    // GUIでコールバックできるように関数を指定
    this.result.bind("select", () => {
      this.selectRouteNo();
    });

    const date = this.type === 'before' ? '20260302' : '20260410';
    this.$store.commit('setIsLoading', true);
    try {
      const response = await this.request('get', Constants.API_BASE_URL + 'v1/json/search/course/extreme?viaList=' + this.viaList.join(':') + '&date=' + date + '&teikiKind=' + this.teikiKind + '&teikiValidity=' + this.teikiValidity + '&mode=' + this.mode + (this.serializeData.length === 0 ? "" : "&corporationBind=none"));
      const result = response.data;
      if (result.ResultSet.Course) {
        for (let c of result.ResultSet.Course) {
          this.setEmptyPrice(c.Price, this.teikiValidity);
          if (c.NormalPrice) {
            this.setEmptyPrice(c.NormalPrice, this.teikiValidity);
          }
          if (c.OffpeakPrice) {
            this.setEmptyPrice(c.OffpeakPrice, this.teikiValidity);
          }
        }
        this.result.setResult(result, this.mode === 'teiki' ? this.result.PRICE_TEIKI : undefined);
      } else {
        if (this.mode === 'teiki') {
          this.errors = [
            'ご入力の経路が見つかりませんでした。',
            '下記をご確認ください。',
            '1.定期券が発行できない区間が含まれている',
            '2.最初の区間がJR以外になっている',
          ];
        } else {
          this.errors = [
            'ご入力の経路が見つかりませんでした。',
            '下記をご確認ください。',
            '1.最初の区間がJR以外になっている',
          ];
        }
      }
    } catch (response) {
      console.log(response);
    } finally {
      this.$store.commit('setIsLoading', false);
    }
  },
  methods: {
    selectRouteNo: function () {
      if (this.serializeData.length <= 2) {
        this.$store.commit('addSerializeData', this.result.getSerializeData());
      }
      this.$router.push({ name: 'TeikiResult' });
    },
    priceChange: async function (url, selectNo, setResultSingle) {
      this.$store.commit('setIsLoading', true);
      try {
        const response = await this.request('get', url);
        const result = response.data;
        if (result.ResultSet.Course) {
          const teiki1Summary = result.ResultSet.Course[0].Price.find(p => p.kind === "Teiki1Summary");
          const teiki3Summary = result.ResultSet.Course[0].Price.find(p => p.kind === "Teiki3Summary");
          const teiki6Summary = result.ResultSet.Course[0].Price.find(p => p.kind === "Teiki6Summary");
          switch (this.teikiValidity) {
            case "1":
              if (teiki1Summary === undefined) {
                this.$store.commit('setAlertModal', '1ヶ月定期が存在しません');
                return;
              }
              break;
            case "3":
              if (teiki3Summary === undefined) {
                this.$store.commit('setAlertModal', '3ヶ月定期が存在しません');
                return;
              }
              break;
            case "6":
              if (teiki6Summary === undefined) {
                this.$store.commit('setAlertModal', '6ヶ月定期が存在しません');
                return;
              }
              break;
          }
          for (let c of result.ResultSet.Course) {
            this.setEmptyPrice(c.Price, this.teikiValidity);
          }
          setResultSingle(JSON.stringify(result), selectNo);
        } else {
          console.log(1234)
        }
      } catch (response) {
        console.log(response);
        this.$store.commit('setAlertModal', '車両種別の変更ができませんでした');
      } finally {
        this.$store.commit('setIsLoading', false);
      }
    },
    back: function () {
      if (this.serializeData.length === 0) {
        this.$router.push({ name: 'TeikiTop', query: { viaList: this.viaList.join(':'), mode: this.mode, type: this.type, teikiKind: this.teikiKind, teikiValidity: this.teikiValidity } });
      } else {
        this.$router.push({ name: 'AddTeiki', query: { viaList: this.viaList.join(':'), mode: this.mode, type: this.type, teikiKind: this.teikiKind, teikiValidity: this.teikiValidity } });
      }
    },
    top: function () {
      this.$store.commit('reset');
      this.$router.push({ name: 'TeikiTop', query: { viaList: this.viaList.join(':'), mode: this.mode, type: this.type, teikiKind: this.teikiKind, teikiValidity: this.validity } });
    },
  }
}
</script>
